import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const WishlistComponet = () => {
  const [wishlist, setWishlist] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?._id;
  const wishlistKey = userId ? `wishlist_${userId}` : null;

  useEffect(() => {
    if (!wishlistKey) return;
    const data = JSON.parse(localStorage.getItem(wishlistKey)) || [];
    setWishlist(data);
  }, [wishlistKey]);

  /* ❌ REMOVE SINGLE ITEM */
  const removeItem = (id) => {
    const updated = wishlist.filter((item) => item._id !== id);
    setWishlist(updated);
    localStorage.setItem(wishlistKey, JSON.stringify(updated));
  };

  /* 🧹 CLEAR ALL */
  const clearAll = () => {
    setWishlist([]);
    localStorage.removeItem(wishlistKey);
  };

  return (
    <div className="w-full bg-white rounded-xl p-4 sm:p-6">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h2 className="text-lg sm:text-xl font-semibold text-teal-700">
          My Wishlist
        </h2>

        {wishlist.length > 0 && (
          <button
            onClick={clearAll}
            className="text-sm sm:text-base text-gray-400 hover:text-red-500"
          >
            Clear All
          </button>
        )}
      </div>

      {/* ITEMS */}
      <div className="space-y-4 sm:space-y-5">

        {wishlist.map((item) => (
          <div
            key={item._id}
            className="
              flex 
              flex-col sm:flex-row 
              sm:items-center 
              justify-between 
              bg-gray-50 
              rounded-xl 
              p-4 
              gap-4
            "
          >

            {/* LEFT */}
            <div className="flex items-center gap-4">

              {/* IMAGE */}
              <img
                src={`https://mediapi.onlinepharmaque.in/uploads/${item.pImg?.[0]}`}
                alt={item.pName}
                className="
                  w-14 h-14 
                  sm:w-16 sm:h-16 
                  object-contain 
                  bg-white 
                  rounded-lg 
                  border
                "
              />

              {/* DETAILS */}
              <div>
                <p className="text-sm sm:text-base font-semibold text-gray-800 line-clamp-2">
                  {item.pName}
                </p>

                <p className="text-xs sm:text-sm text-gray-500 mt-1 line-clamp-2">
                  {item.description || "Best quality product"}
                </p>

                <p className="text-sm sm:text-base font-bold text-gray-900 mt-2">
                  ₹ {item.price}
                </p>
              </div>

            </div>

            {/* RIGHT (Mobile me niche aayega) */}
            <div className="flex justify-end sm:block">
              <button
                onClick={() => removeItem(item._id)}
                className="
                  text-gray-400 
                  hover:text-red-500 
                  text-xl sm:text-2xl
                "
              >
                <IoClose />
              </button>
            </div>

          </div>
        ))}

        {/* EMPTY */}
        {wishlist.length === 0 && (
          <div className="text-center py-10 sm:py-12">
            <p className="text-base sm:text-lg text-gray-400">
              Your wishlist is empty 😔
            </p>
          </div>
        )}

      </div>
    </div>
  );
};

export default WishlistComponet;